if (!window.Maximize.loadedScript.includes("vendor-recommendations.js")) {
  window.Maximize.loadedScript.push("vendor-recommendations.js");

  function showContentAndHideSkeleton(wrapperEl) {
    const skeletonEl = wrapperEl.querySelector("[data-vendor-skeleton]");
    const contentEl = wrapperEl.querySelector("[data-vendor-content]");
    if (skeletonEl) skeletonEl.style.display = "none";
    if (contentEl) contentEl.style.display = "";
  }

  function hideWholeSection(wrapperEl) {
    const outer = wrapperEl.closest(".vendor-recommendations__wrapper");
    if (outer) outer.style.display = "none";
  }

  function getHandleFromUrl(url) {
    if (!url) return null;
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Each card's product-variant link carries an `x-labels-data` attribute
  // containing a JSON blob with an "available" boolean (visible in the
  // sample markup: { "id": ..., "available": true, ... }). That's the
  // only place stock status shows up in the fetched HTML, so we parse it
  // directly rather than relying on any specific rendered "in stock" text
  // (which can vary/be translated).
  function isCardAvailable(card) {
    const link = card.querySelector("[x-labels-data]");
    if (!link) return true; // unknown -> don't filter it out
    const raw = link.getAttribute("x-labels-data");
    if (!raw) return true;
    try {
      const data = JSON.parse(raw.trim());
      if (typeof data.available === "boolean") return data.available;
      return true;
    } catch (e) {
      console.warn("[vendor-recs][DEBUG] failed to parse x-labels-data for availability check:", e, card);
      return true;
    }
  }

  function debugImages(container) {
    const imgs = container.querySelectorAll("img");
    console.log(`[vendor-recs][DEBUG] Found ${imgs.length} <img> tags. Dumping first 3:`);
    Array.from(imgs).slice(0, 3).forEach((img, i) => {
      const attrs = {};
      for (const attr of img.attributes) attrs[attr.name] = attr.value;
      console.log(`[vendor-recs][DEBUG] img[${i}] attributes:`, attrs);
      console.log(`[vendor-recs][DEBUG] img[${i}] computed src:`, img.currentSrc || img.src);
      console.log(`[vendor-recs][DEBUG] img[${i}] naturalWidth (0 = failed to load):`, img.naturalWidth);
    });

    // also check for <picture><source> patterns
    const sources = container.querySelectorAll("source");
    console.log(`[vendor-recs][DEBUG] Found ${sources.length} <source> tags.`);
  }

  function toCamel(str) {
    return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
  }

  // ---------------------------------------------------------------------
  // fixLazyImages
  //
  // The previous version only checked a hardcoded, incomplete list of
  // dataset keys (src, srcset, original, lazySrc) and had a dead loop that
  // never actually did anything. This version:
  //   1. Walks EVERY data-* attribute on each <img>/<source> element
  //      instead of guessing a fixed list, so it works regardless of which
  //      lazyload convention the theme/vendor markup uses.
  //   2. Maps common "source" style attrs -> src, "srcset" style attrs ->
  //      srcset, and "sizes" style attrs -> sizes, based on naming
  //      patterns rather than a single hardcoded key.
  //   3. Only overwrites src/srcset if a real (non-empty, non-placeholder)
  //      value is found, so we don't clobber already-correct attributes.
  //   4. Logs exactly which attribute it used, so if something still
  //      doesn't load you can see why immediately in the console.
  // ---------------------------------------------------------------------
  function isPlaceholder(value) {
    if (!value) return true;
    const v = value.trim().toLowerCase();
    return (
      v === "" ||
      v.startsWith("data:image/gif;base64") || // classic 1x1 placeholder
      v.includes("blank.gif") ||
      v.includes("placeholder")
    );
  }

  function fixLazyImages(container) {
    const mediaEls = container.querySelectorAll("img, source");

    mediaEls.forEach((el) => {
      const dataset = el.dataset || {};
      let chosenSrcAttr = null;
      let chosenSrcsetAttr = null;
      let chosenSizesAttr = null;

      // Inspect every data-* attribute present on the element and bucket
      // it by what it looks like it's for, based on naming conventions.
      Object.keys(dataset).forEach((key) => {
        const lowerKey = key.toLowerCase();
        const value = dataset[key];
        if (!value) return;

        if (lowerKey.includes("srcset")) {
          chosenSrcsetAttr = chosenSrcsetAttr || key;
        } else if (lowerKey.includes("sizes")) {
          chosenSizesAttr = chosenSizesAttr || key;
        } else if (
          lowerKey === "src" ||
          lowerKey.includes("original") ||
          lowerKey.includes("lazysrc") ||
          lowerKey.includes("lazy") ||
          lowerKey.includes("master") ||
          lowerKey.includes("photoswipe") ||
          lowerKey.includes("large")
        ) {
          chosenSrcAttr = chosenSrcAttr || key;
        }
      });

      // Apply src
      if (chosenSrcAttr && !isPlaceholder(dataset[chosenSrcAttr])) {
        if (isPlaceholder(el.getAttribute("src"))) {
          el.setAttribute("src", dataset[chosenSrcAttr]);
          console.log(
            `[vendor-recs][DEBUG] Set src from data-${chosenSrcAttr.replace(
              /([A-Z])/g,
              "-$1"
            ).toLowerCase()} ->`,
            dataset[chosenSrcAttr]
          );
        }
      }

      // Apply srcset
      if (chosenSrcsetAttr && dataset[chosenSrcsetAttr]) {
        el.setAttribute("srcset", dataset[chosenSrcsetAttr]);
      }

      // Apply sizes (only from an attribute that actually looks like sizes,
      // NOT from data-widths as the old code incorrectly did)
      if (chosenSizesAttr && dataset[chosenSizesAttr]) {
        el.setAttribute("sizes", dataset[chosenSizesAttr]);
      }

      // If after all this the element still has no usable src/srcset, log
      // it loudly so it's obvious in the console which images are still
      // broken and what attributes were available on them.
      const finalSrc = el.getAttribute("src");
      const finalSrcset = el.getAttribute("srcset");
      if (isPlaceholder(finalSrc) && !finalSrcset) {
        console.warn(
          "[vendor-recs][DEBUG] Could not resolve a real image source for element. Available data-* attrs:",
          { ...dataset },
          el
        );
      }

      el.classList.remove("lazyload", "lazyloading");
      el.classList.add("lazyloaded");
    });

    if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.checkElems) {
      window.lazySizes.loader.checkElems();
    }

    // Some themes use IntersectionObserver-driven lazyload libs that only
    // scan images present at DOMContentLoaded. Give them a nudge by firing
    // a scroll/resize event, which is what many of them listen for.
    window.dispatchEvent(new Event("scroll"));
    window.dispatchEvent(new Event("resize"));
  }

  // ---------------------------------------------------------------------
  // fixBrokenAspectRatioWrappers
  //
  // Some vendor/collection responses render the image wrapper with an
  // invalid Tailwind arbitrary value, e.g. class="... pb-[auto%] ...".
  // `padding-bottom: auto%` is not valid CSS, so the browser drops the
  // rule, the wrapper collapses to ~0 height, and the <img> inside
  // (absolute + h-full) becomes invisible even though it loaded fine.
  //
  // Fix: for every .product-card__image-wrapper, if it has no real
  // rendered height but contains an <img> with width/height attributes,
  // compute the aspect ratio ourselves and set an inline padding-bottom,
  // which overrides the broken/no-op utility class.
  // ---------------------------------------------------------------------
  // The theme's product-card grid always uses a fixed 1:1 (square) image
  // box — confirmed by the scoped <style> block the theme itself injects
  // for correctly-rendered cards (e.g. `padding-bottom: 100.0%;` scoped to
  // #ProductCard_...). The <img>'s width/height attributes do NOT reflect
  // this — they're just whatever crop variant happened to be requested
  // from the CDN (e.g. 500x166), so deriving the ratio from them produces
  // a thin, wrong "letterbox" box instead of the intended square crop.
  const PRODUCT_CARD_IMAGE_ASPECT_RATIO_PERCENT = 100;

  function fixBrokenAspectRatioWrappers(container) {
    const wrappers = container.querySelectorAll(".product-card__image-wrapper");
    wrappers.forEach((wrapper) => {
      const rect = wrapper.getBoundingClientRect();
      if (rect.height > 4) return; // already has real height, leave it alone

      wrapper.style.paddingBottom = `${PRODUCT_CARD_IMAGE_ASPECT_RATIO_PERCENT}%`;
      console.log(
        `[vendor-recs][DEBUG] Wrapper had no height (broken pb-[auto%] class). ` +
          `Applied fixed inline padding-bottom: ${PRODUCT_CARD_IMAGE_ASPECT_RATIO_PERCENT}% ` +
          `(matches the theme's standard square card image box).`,
        wrapper
      );
    });
  }

  function debugAlpineStores() {
    if (!window.Alpine) {
      console.warn("[vendor-recs][DEBUG] window.Alpine is not defined at all.");
      return;
    }
    try {
      console.log("[vendor-recs][DEBUG] Alpine version:", Alpine.version);
      console.log("[vendor-recs][DEBUG] Attempting Alpine.store('xLabelsAndBadges'):", Alpine.store("xLabelsAndBadges"));
      console.log("[vendor-recs][DEBUG] Attempting Alpine.store('xSwiffy'):", Alpine.store("xSwiffy"));
      console.log("[vendor-recs][DEBUG] Attempting Alpine.store('xQuickView'):", Alpine.store("xQuickView"));
      // Log every registered store name if Alpine exposes its internal
      // registry, so we can spot an image/media-specific store we haven't
      // accounted for (e.g. xMedia, xLazyload, xImages, etc.)
      if (Alpine.store && Alpine.store.__proto__) {
        console.log("[vendor-recs][DEBUG] Alpine store registry (raw):", Alpine.store);
      }
    } catch (e) {
      console.error("[vendor-recs][DEBUG] Error inspecting Alpine stores:", e);
    }
  }

  function triggerLabelsAndBadges(container) {
    if (!window.Alpine) return;
    const store = Alpine.store("xLabelsAndBadges");
    if (!store || !store.load) {
      console.warn("[vendor-recs][DEBUG] xLabelsAndBadges store or .load() not found — badges cannot be triggered manually.");
      return;
    }

    const labelEls = container.querySelectorAll("[x-labels-data]");
    console.log(`[vendor-recs][DEBUG] Found ${labelEls.length} elements with x-labels-data.`);
    labelEls.forEach((el, i) => {
      try {
        console.log(`[vendor-recs][DEBUG] Calling xLabelsAndBadges.load() on element ${i}`, el);
        store.load(el);
      } catch (e) {
        console.error("[vendor-recs][DEBUG] failed to load badge for element:", el, e);
      }
    });
  }

  // Also try any obvious media/image Alpine stores the theme might expose,
  // mirroring how xLabelsAndBadges is handled above. This is a no-op if
  // none of these stores exist.
  function triggerImageStores(container) {
    if (!window.Alpine) return;
    const candidateStoreNames = ["xMedia", "xImages", "xLazyload", "xLazyLoad", "xImageLoader"];
    candidateStoreNames.forEach((name) => {
      const store = Alpine.store(name);
      if (store && typeof store.load === "function") {
        console.log(`[vendor-recs][DEBUG] Found Alpine store '${name}', calling .load() on container.`);
        try {
          store.load(container);
        } catch (e) {
          console.error(`[vendor-recs][DEBUG] failed calling ${name}.load():`, e);
        }
      }
    });
  }

  function initSlider(sliderEl) {
    if (!sliderEl || sliderEl.dataset.swiffyInitialized) return;
    const configString = sliderEl.dataset.swiffyConfig;
    let config = {};
    try {
      config = configString ? JSON.parse(configString) : {};
    } catch (e) {
      console.error("[vendor-recs] failed to parse swiffy config:", e);
    }
    if (window.Alpine && Alpine.store("xSwiffy") && Alpine.store("xSwiffy").load) {
      Alpine.store("xSwiffy").load(sliderEl, config);
      sliderEl.dataset.swiffyInitialized = "true";
    } else if (window.SwiffySlider) {
      new SwiffySlider(sliderEl, config);
      sliderEl.dataset.swiffyInitialized = "true";
    }
  }

  function registerVendorRecommendationsStore() {
    if (!window.Alpine || Alpine.store("xVendorRecommendations")) return;

    Alpine.store("xVendorRecommendations", {
      load(wrapperEl) {
        const vendor = wrapperEl.dataset.vendor;
        if (!vendor) {
          hideWholeSection(wrapperEl);
          return Promise.resolve();
        }

        const currentUrl = wrapperEl.dataset.currentUrl;
        const currentHandle = getHandleFromUrl(currentUrl);
        const maxProducts = parseInt(wrapperEl.dataset.maxProducts, 10) || 6;
        const availableOnly = wrapperEl.dataset.availableOnly === "true";
        const target = wrapperEl.querySelector("[data-vendor-products-target]");
        const sliderEl = wrapperEl.querySelector("[data-vendor-slider]");

        // Falls back to the old hardcoded path only if the section markup
        // hasn't been updated yet with data-vendor-collection-url. Passing
        // it from Liquid (built off routes.root_url) ensures this request
        // hits the same locale the customer is currently browsing in,
        // e.g. "/ar/collections/vendors" instead of always the default.
        const collectionBaseUrl = wrapperEl.dataset.vendorCollectionUrl || "/collections/vendors";
        const fetchUrl = `${collectionBaseUrl}?q=${encodeURIComponent(vendor)}`;

        return fetch(fetchUrl)
          .then((response) => response.text())
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, "text/html");
            const CARD_SELECTOR = ".product-card__wrapper";
            let cards = Array.from(parsed.querySelectorAll(CARD_SELECTOR));

            const seenHandles = new Set();
            cards = cards.filter((card) => {
              const link = card.querySelector('a[href*="/products/"]');
              const handle = link ? getHandleFromUrl(link.getAttribute("href")) : null;
              if (!handle || handle === currentHandle || seenHandles.has(handle)) return false;
              seenHandles.add(handle);
              return true;
            });

            if (availableOnly) {
              const beforeCount = cards.length;
              cards = cards.filter(isCardAvailable);
              console.log(
                `[vendor-recs][DEBUG] Availability filter: ${beforeCount} -> ${cards.length} cards after removing out-of-stock items.`
              );
            }

            cards = cards.slice(0, maxProducts);

            if (cards.length === 0) {
              hideWholeSection(wrapperEl);
              return;
            }

            target.innerHTML = "";
            cards.forEach((card) => {
              const slide = document.createElement("div");
              slide.className = "slide-item product-recommendation__item";
              slide.innerHTML = card.outerHTML;
              target.appendChild(slide);
            });

            console.log("[vendor-recs][DEBUG] === BEFORE fixLazyImages ===");
            debugImages(target);

            fixLazyImages(target);
            fixBrokenAspectRatioWrappers(target);

            showContentAndHideSkeleton(wrapperEl);

            if (window.Alpine && Alpine.initTree) {
              Alpine.initTree(target);
            }

            debugAlpineStores();
            triggerLabelsAndBadges(target);
            triggerImageStores(target);

            requestAnimationFrame(() => {
              initSlider(sliderEl);
              // Re-check in case the container wasn't laid out/painted yet
              // on the first pass (rect.height would read 0 either way).
              fixBrokenAspectRatioWrappers(target);

              console.log("[vendor-recs][DEBUG] === AFTER everything (1s later) ===");
              setTimeout(() => debugImages(target), 1000);
            });

            document.dispatchEvent(new CustomEvent("maximize:animation:reveal"));
          })
          .catch((e) => {
            console.error("[vendor-recs] fetch failed:", e);
            hideWholeSection(wrapperEl);
          });
      },
    });
  }

  if (window.Alpine) {
    registerVendorRecommendationsStore();
  } else {
    document.addEventListener("alpine:init", registerVendorRecommendationsStore);
  }
}
